//////////////////////////////////////////////////////////////////////
//
//  10/02/18
//  src/containers/BBoard.js
//
//  This file will display a Black Board Pic with Text.
//

import React, { Component } from "react";
import BLine from "./BLine";
import BBoardPic from "../images/BBClear.png";
import './BBoard.css';

class BBoard extends Component {
  constructor( props ) {
    super( props );
    this.state = {
      line1 : "",
      line2 : "",
      line3 : "",
      line4 : ""
    };
  }

  render() {
    const { line1, line2, line3, line4 } = this.props;
    const ltop1 = "40";
    const ltop2 = "80";
    const ltop3 = "120";
    const ltop4 = "160";

    return (
      <div className="BBoardTop">
        <BLine bl_top={ ltop1 } bl_txt={ line1 } />
        <BLine bl_top={ ltop2 } bl_txt={ line2 } />
        <BLine bl_top={ ltop3 } bl_txt={ line3 } />
        <BLine bl_top={ ltop4 } bl_txt={ line4 } />
        <img className="BBoardPic" src={ BBoardPic  } alt={ line1 } />
      </div>
    );
  }
}

export default BBoard;




// WEBPACK FOOTER //
// ./src/components/BBoard.js